// extracted by mini-css-extract-plugin
module.exports = {"socials":"Socials-styles-module--socials--3iTz3"};